<template>
  <div class="visionboard-sidebar">
    <el-button class="btn-block d-block mx-auto w-100" @click="toggleVisionboardChallengeSidebar">Close</el-button>

    <!-- <pre>{{challenges}}</pre> -->
  </div>
  <!--
  <v-group :config="groupConfig" ref="group">
    <v-image v-for="challenge in challenges"
      :key="challenge.challengeId"
      :config="challenge.image"
      @mouseover="/*handleStageClickOrTap*/"/>
  </v-group>
  -->
</template>

<script>
import { mapActions } from "vuex";
// const challengeData = require('@/store/goal/challenge/challengedata');

export default {
  data: () => ({
    // challenges: challengeData.challenges,
    // challengeOptions: challengeData.challengeOptions,
  }),
  methods: {
    ...mapActions("app", [
      'toggleVisionboardChallengeSidebar'
    ]),
  }
}
</script>
